<div class="background">
  <div class="card">
    <div class="content-holder" *ngIf="!submitSuccess">
      <p class="body-bold-20">{{'general.forgot_your_password' | translate}}</p>
      <p class="caption12 margined">{{'general.we_will_send_link' | translate}}</p>
      <p class="bordered"></p>

      <form class="flex-form" [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-outline" id="emil-form">
          <app-text-input
            id="email"
            name="email"
            type="email"
            [label]="'general.your_email' | translate"
            [errorMessage]="'errors.invalid_email' | translate"
            [showError]="email.invalid && formSubmitAttempt"
            formControlName="email">
          </app-text-input>
        </div>
        <div class="form-outline flex center">
          <button type="submit" class="primary-blue-500 primary-sumbit" id="signin-button">{{'general.send_reset_link' |
            translate}}</button>
        </div>
      </form>
    </div>
    <check-inbox *ngIf="submitSuccess" [Email]="email.value"></check-inbox>
  </div>
</div>